import { IconButton } from '@mui/material'
import IconBack from '../icons/IconBack'
import { useNavigate } from 'react-router'
import { useContext } from 'react'
import { HotelContext } from '../contexts/HotelContext'
import { useConfirm } from 'material-ui-confirm'

interface IBackButtonProps {
  to: string
}

export const BackButton = ({ to }: IBackButtonProps) => {
  const navigate = useNavigate()
  const { hotel, reservation, clearReservationToken } = useContext(HotelContext)
  const confirm = useConfirm()
  const handleBack = async () => {
    if (hotel && reservation && to === `/hotel/${hotel.hotelId}`) {
      try {
        await confirm({
          description: 'Kết thúc tự nhận phòng và quay lại trang chủ',
          title: 'Bạn có muốn kết thúc tự nhận phòng?',
        })
        await clearReservationToken()
      } catch (err) {
        return
      }
    }

    navigate(to)
  }

  return (
    <IconButton style={{ position: 'absolute', top: '0.5rem', left: '0.5rem' }} onClick={handleBack}>
      <IconBack />
    </IconButton>
  )
}
